import * as formik from 'formik';
import * as fabric from 'office-ui-fabric-react';
import { FC, useState } from 'react';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import * as api from '../../../../../api/generated';
import { KendoLoading } from '../../../../../components';
import { IWindowComponentProps } from '../../../../../components/windows/WindowContext';
import { IQueueListItem } from '../../../../../models/classes/IQueue';

interface IQueueCreateModalProps {
    refetchQueues(): Promise<void>;
}

const validationSchema = Yup.object<IQueueListItem>().shape({
    name: Yup.string().required('Šis laukas yra privalomas')
});

const QueueCreateModalWindow: FC<IWindowComponentProps<IQueueCreateModalProps>> = (props) => {
    const {
        componentProps: { refetchQueues },
        onClose
    } = props;

    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (values: IQueueListItem, formikActions: formik.FormikHelpers<IQueueListItem>) => {
        try {
            setIsLoading(true);
            formikActions.setStatus();
            await api.administration.createQueue(values.name);
            toast.success('Eilė sėkmingai sukurta');
            await refetchQueues();
        } catch (ex) {
            formikActions.setStatus(ex);
            toast.error(ex.error[0]);
        } finally {
            formikActions.setSubmitting(false);
            setIsLoading(false);
            onClose();
        }
    };

    return (
        <>
            {isLoading ? (
                <KendoLoading />
            ) : (
                <>
                    <formik.Formik validationSchema={validationSchema} initialValues={{} as IQueueListItem} onSubmit={handleSubmit}>
                        {(formikProps) => (
                            <formik.Form>
                                <div className="ms-Grid-row">
                                    <formik.Field
                                        name="name"
                                        render={({ field, form }: formik.FieldProps<string>) => (
                                            <fabric.TextField
                                                label="Eilės pavadinimas"
                                                {...field}
                                                errorMessage={
                                                    (formikProps.status && formikProps.status.name) || (form.errors.name && form.errors.name)
                                                }
                                            />
                                        )}
                                    />
                                </div>
                                <div style={{ textAlign: 'center', marginTop: '30px' }}>
                                    <fabric.PrimaryButton
                                        className="ms-slideRightIn40 ms-textAlignRight"
                                        text="Išsaugoti"
                                        disabled={formikProps.isSubmitting || !formikProps.isValid || !formikProps.dirty}
                                        type="submit"
                                    />
                                </div>
                            </formik.Form>
                        )}
                    </formik.Formik>
                </>
            )}
        </>
    );
};

export default QueueCreateModalWindow;
